import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useLocation } from 'react-router-dom';
import toast from 'react-hot-toast';
import api from '../utils/api';
import { services } from '../utils/servicesData';

export default function BookService() {
  const location = useLocation();
  const preselected = new URLSearchParams(location.search).get('service') || '';
  const [form, setForm] = useState({ clientName:'', email:'', phone:'', company:'', service: preselected, preferredDate:'', message:'' });
  const [files, setFiles] = useState([]);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault(); setSubmitting(true);
    try {
      const fd = new FormData();
      Object.entries(form).forEach(([k,v]) => fd.append(k,v));
      files.forEach(f => fd.append('attachments', f));
      await api.post('/bookings', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      toast.success('Booking submitted! We\'ll confirm within 24 hours.');
      setForm({ clientName:'', email:'', phone:'', company:'', service:'', preferredDate:'', message:'' });
      setFiles([]);
    } catch { toast.error('Submission failed. Please try again.'); }
    setSubmitting(false);
  };

  return (
    <div style={{ paddingTop: 74 }}>
      <section style={{ background: 'linear-gradient(135deg, #060F1E 0%, var(--navy) 100%)', padding: '5.5rem 0 4rem' }}>
        <div className="container">
          <span className="label" style={{ marginBottom: '1rem', display: 'inline-flex' }}>Get Started</span>
          <h1 style={{ fontFamily: 'Fraunces, serif', fontSize: 'clamp(2.2rem,4vw,3.2rem)', color: 'white', marginBottom: '1.25rem', lineHeight: 1.15 }}>Book a Service</h1>
          <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: '1.05rem', maxWidth: 520, lineHeight: 1.75 }}>Fill in the form below and we'll get back to you within 24 hours to confirm your booking.</p>
        </div>
      </section>

      <section className="section-pad" style={{ background: 'var(--off-white)' }}>
        <div className="container" style={{ maxWidth: 840 }}>
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} style={{ background: 'white', padding: '3rem', borderRadius: '24px', boxShadow: 'var(--shadow-lg)', border: '1px solid var(--gray-100)' }}>
            <h2 style={{ fontFamily: 'Fraunces, serif', fontSize: '1.4rem', color: 'var(--navy)', marginBottom: '2rem' }}>Service Booking Form</h2>
            <form onSubmit={handleSubmit}>
              <div className="grid-2">
                <div className="form-group"><label className="form-label">Full Name *</label><input className="form-input" required value={form.clientName} onChange={e => setForm({...form, clientName: e.target.value})} placeholder="Your full name" /></div>
                <div className="form-group"><label className="form-label">Email Address *</label><input className="form-input" type="email" required value={form.email} onChange={e => setForm({...form, email: e.target.value})} placeholder="your@email.com" /></div>
              </div>
              <div className="grid-2">
                <div className="form-group"><label className="form-label">Phone Number</label><input className="form-input" value={form.phone} onChange={e => setForm({...form, phone: e.target.value})} placeholder="+233 XX XXX XXXX" /></div>
                <div className="form-group"><label className="form-label">Company Name</label><input className="form-input" value={form.company} onChange={e => setForm({...form, company: e.target.value})} placeholder="Your company" /></div>
              </div>
              <div className="grid-2">
                <div className="form-group">
                  <label className="form-label">Service Required *</label>
                  <select className="form-input" required value={form.service} onChange={e => setForm({...form, service: e.target.value})}>
                    <option value="">-- Select a Service --</option>
                    {services.map(s => <option key={s.id} value={s.title}>{s.title}</option>)}
                  </select>
                </div>
                <div className="form-group"><label className="form-label">Preferred Date</label><input className="form-input" type="date" value={form.preferredDate} onChange={e => setForm({...form, preferredDate: e.target.value})} min={new Date().toISOString().split('T')[0]} /></div>
              </div>
              <div className="form-group"><label className="form-label">Additional Details</label><textarea className="form-input" style={{ minHeight: 130 }} value={form.message} onChange={e => setForm({...form, message: e.target.value})} placeholder="Tell us more about your requirements, challenges, or specific areas of concern..." /></div>
              <div className="form-group">
                <label className="form-label">Supporting Documents (optional)</label>
                <input type="file" multiple accept=".pdf,.doc,.docx,.jpg,.png" onChange={e => setFiles([...e.target.files])} style={{ display: 'block', padding: '0.65rem 1rem', border: '1.5px dashed var(--gray-300)', borderRadius: '10px', width: '100%', fontSize: '0.875rem', cursor: 'pointer', background: 'var(--gray-50)' }} />
              </div>
              <div style={{ background: 'var(--off-white)', padding: '1.25rem', borderRadius: '12px', marginBottom: '1.5rem', fontSize: '0.875rem', color: 'var(--gray-500)', lineHeight: 1.7, border: '1px solid var(--gray-200)' }}>
                <strong style={{ color: 'var(--navy)' }}>What happens next?</strong> Our team will review your request and contact you within 24 business hours to confirm your booking and discuss next steps.
              </div>
              <button type="submit" className="btn btn-gold" style={{ width: '100%', justifyContent: 'center', fontSize: '0.95rem', padding: '0.9rem' }} disabled={submitting}>
                {submitting ? 'Submitting...' : 'Submit Booking Request'}
              </button>
            </form>
          </motion.div>
        </div>
      </section>
    </div>
  );
}
